import React, { lazy, useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { ClickAwayListener } from '@material-ui/core';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Label = lazy(() => import(`globalcomponents/UI/Label/${layout}`));
const ToolTip = lazy(() => import(`../ToolTip`));

const TitleToolTip = ({ title, info, className, small }) => {
  const [isTooltipOpen, setTooltipOpen] = useState(false);
  const tooltipRef = useRef(null);
  const debounceTimeout = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        setTooltipOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const handleClick = (event) => {
    event.stopPropagation();
    setTooltipOpen((prev) => !prev);
  };

  const handleMouseEnter = () => {
    clearTimeout(debounceTimeout.current);
    setTooltipOpen(true);
  };

  const handleMouseLeave = () => {
    debounceTimeout.current = setTimeout(() => {
      setTooltipOpen(false);
    }, 200);
  };

  return (
    <div ref={tooltipRef}>
      <Label
        {...(small
          ? { className }
          : { variant: 'body1', className: `statsHeading ${className}` })}
      >
        {title}
        <ToolTip
          id="tooltips"
          arrow
          title={
            <ClickAwayListener onClickAway={() => setTooltipOpen(false)}>
              <p
                style={{
                  zIndex: 1500,
                  pointerEvents: 'auto',
                  cursor: 'text',
                }}
              >
                {info}
              </p>
            </ClickAwayListener>
          }
          placement="top"
          followCursor
          open={isTooltipOpen}
          disableHoverListener
        >
          <span
            onClick={handleClick}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            style={{ cursor: 'pointer' }}
          >
            <InfoOutlinedIcon />
          </span>
        </ToolTip>
      </Label>
    </div>
  );
};

TitleToolTip.propTypes = {
  title: PropTypes.string.isRequired,
  info: PropTypes.string.isRequired,
  className: PropTypes.string,
  small: PropTypes.bool,
};

TitleToolTip.defaultProps = {
  className: '',
  small: false,
};

export default TitleToolTip;